<template>
    <div class="head-container row">
        <div class="container-fluid px-2">
            <b-tabs align="left">
                <template v-slot:tabs-start>
                    <b-nav-item class="head-icon" @click="closeTabs()">
                        <i class="fas fa-chevron-left"></i>
                    </b-nav-item>
                </template>

                <b-tab
                    v-for="section in sections"
                    :key="section.id"
                    :title="section.title"
                    :active="section.active"
                    :disabled="section.disabled"
                >
                    <component :is="section.content"/>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import BTabItem from './BTabItem.vue'
import ImageManager from '../molecules/ImageManager.vue'
import VideoManager from '../molecules/VideoManager.vue'
export default {
    name: "HeaderTab",
    components: {
        BTabItem,
        ImageManager,
        VideoManager
    },
    props: {
        sections: {
            type: Array,
            required: true
        }
    },
    methods: {
        closeTabs() {
            let vm = this.$parent

            vm.$emit("closeTabs");
        }
    }
}
</script>

<style>
    .head-container {
        position: relative;
        color: #000000;
        background-color: #ffffff;
    }

    .head-container .nav.nav-tabs {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 601;
        background-color: #FFFFFF;
    }

    .head-icon a i {
        /* font-size: 35px; */
        color: var(--main-color) !important;
    }

    .media--manager .nav-tabs .nav-link, .media--manager .nav-tabs .nav-link.active {
        border: none!important;
    }

    .nav-item:has(.nav-link[aria-disabled="true"]) {
        cursor: not-allowed;
    }
    
    .media--manager .nav-link {
        color: #707070;
        font-weight: 700;
        border: none;
    }

    .media--manager .nav-tabs .nav-link.active {
        color: #000000;
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/atoms/HeaderBTab.vue